module.exports = __webpack_public_path__ + "images/emoji/e-mail.00492371c5756e2b0d45.png";